<template>
  <div>
    <b-row>
      <b-col class="col-md-2">
        <AppSearchInput
          :label="$t('search') + ':'"
          :placeholder="$t('search') + '...'"
        />
      </b-col>
    </b-row>

    <b-card>
      <h6 class="mb-1">
        {{$t('reference.material')}}
      </h6>
      <b-table
        :fields="fields"
        :items="items"
        show-empty
        responsive
        :empty-text="$t('empty_text')"
      >
        <template #head()="props">
          <span>{{ $t(props.label) }}</span>
        </template>

        <template #cell(actions)>
          <div>
            <b-button
              v-b-modal.modal-material-warehouse2
              variant="outline-success"
              size="sm"
              class="mt-50 mb-50"
            >
              Поделиться
            </b-button>
          </div>
        </template>
      </b-table>
    </b-card>

    

    <b-row class="mt-5">
      <b-col class="col-md-2">
        <b-form-group
          label="Поиск категории:"
        >
          <b-input-group class="input-group-merge">
            <b-input-group-prepend is-text>
              <feather-icon icon="SearchIcon" />
            </b-input-group-prepend>
            <b-form-input
              v-model="filterData.search"
              :placeholder="$t(&quot;search&quot;)"
              class="d-inline-block mb-0"
              type="text"
            />
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col class="col-md-2">
        <b-form-group
          label="Поиск наименование:"
        >
          <b-input-group class="input-group-merge">
            <b-input-group-prepend is-text>
              <feather-icon icon="SearchIcon" />
            </b-input-group-prepend>
            <b-form-input
              v-model="filterData.search"
              :placeholder="$t(&quot;search&quot;)"
              class="d-inline-block mb-0"
              type="text"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <b-card>
      <h6 class="mb-1">
        {{$t('reference.instrument')}}
      </h6>
      <b-table
        :fields="fieldsIns"
        :items="itemsIns"
        show-empty
        responsive
        :empty-text="$t('empty_text')"
      >
        <template #head()="props">
          <span>{{ $t(props.label) }}</span>
        </template>

        <template #cell(actions)>
          <div>
            <b-button
              v-b-modal.modal-instrument-warehouse2
              variant="outline-success"
              size="sm"
              class="mt-50 mb-50"
            >
              Поделиться
            </b-button>
          </div>
        </template>
      </b-table>
    </b-card>

    <instrumentModalWarehouse />
    <materialModal />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BTable,
  BCard,
  BButton,
  BFormInput,
  BInputGroupPrepend,
  BInputGroup,
} from 'bootstrap-vue'
import AppSearchInput from '@/components/AppSearchInput.vue'
import instrumentModalWarehouse from './instrumentModal.vue'
import materialModal from './materialModal.vue'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BTable,
    BCard,
    BButton,
    AppSearchInput,
    BFormInput,
    BInputGroupPrepend,
    BInputGroup,
    materialModal,
    instrumentModalWarehouse,
  },

  data() {
    return {
      filterData: {
        search: '',
      },
      fields: [
        {
          label: '№',
          key: 'id',
        },
        {
          label: 'reference.character',
          key: 'character',
        },
        {
          label: 'reference.units',
          key: 'units',
        },
        {
          label: 'amount',
          key: 'count',
        },
        {
          label: 'where',
          key: 'where',
        },
        {
          label: 'actions',
          key: 'actions',
        },
      ],
      items: [
        {
          id: 1,
          character: 'G\'ish',
          units: 'KG',
          count: '800',
          where: 'warehouse 100/200',
        },
      ],

      // instruments

      fieldsIns: [
        {
          label: '№',
          key: 'id',
        },
        {
          label: 'model',
          key: 'model',
        },
        {
          label: 'amount',
          key: 'where',
        },
        {
          label: 'where',
          key: 'where',
        },
        {
          label: 'actions',
          key: 'actions',
        },
      ],

      itemsIns: [
        {
          id: 1,
          model: 'G\'ish',
          counts: 'KG',
          where: '800',
        },
      ],
    }
  },
}
</script>

<style scoped>

</style>
